export default  {
    "PLACE": {
        "PLACE": "Helyszín",
        "NAME": "Név",
        "CITY": "Város",
        "CITIES": "Városok",
        "LOCATION": "Pozíció",
        "ADDRESS": "Cím",
        "DESCRIPTION": "Leírás",
        "ADDRESS_SEARCH": "Cím kereső",
        "MARKER_POS": "Jelölő pozíciója (y,x)",
        "MARKER_COLOR": "Jelölő színe",
        "MARKER_DIR": "Jelölő iránya",
        "TYPE": "Típus",
    }
}


// WEBPACK FOOTER //
// ./src/i18n/messages/hu/place.js